module.exports = __webpack_public_path__ + "img/light-rain.dbc1f43a.svg";